import { useFormikContext } from 'formik';

// import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';
// import { useMacrosContext } from 'lib/context/MacrosContext/MacrosContext';
// import { io } from 'lib/helpers/utility';

// import { getTypeOfNotes } from 'components/practice/charts/ClinicalNote/MyScribeAI/lib/helpers';
// import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';

// import Typography from 'components/shared/Typography/Typography';

// import FormSelect from '../FormSelect/FormSelect';
// import FormsList from '../FormsList';
// import NoteSelect from '../NoteSelect';

const FormMacroForm = () => {
  const { values, errors, setFieldValue } = useFormikContext();

  // const { cnDisplaySettings, advancedHP, advancedSOAP, customFormTypes } = useClinicalNoteContext();

  // const { activeMacro } = useMacrosContext();

  // console.log(
  //   '%csrc/components/practice/charts/ClinicalNote/Sidebar/Macros/UpsertMacro/components/Forms/FormMacroForm.jsx:22 {values}',
  //   'color: #007acc;',
  //   { values }
  // );

  // const typeOfNotes = getTypeOfNotes({
  //   cnDisplaySettings,
  //   advancedHP,
  //   advancedSOAP,
  //   customFormTypes
  // });

  // const selectFormsHandler = (note, value) => {
  //   const components = typeOfNotes?.[note]?.components;

  //   if (io(components)) {
  //     const exists = Object.entries(components).find(([key, comp]) =>
  //       [key, comp.key].includes(value)
  //     );

  //     // console.log(
  //     //   '%csrc/components/practice/charts/ClinicalNote/Sidebar/Macros/UpsertMacro/components/Forms/FormMacroForm.jsx:35 {value,components}',
  //     //   'color: #007acc;',
  //     //   { value, components }
  //     // );

  //     if (exists) {
  //       const newValue = { [note]: [value] };

  //       setFieldValue('body', { forms: newValue });
  //     }
  //   }
  // };

  // const selectNoteHandler = (note) => {
  //   setFieldValue('note', note);
  // };

  // const forms = values?.body?.forms;
  // const note = values?.note;

  // const hasForms = io(forms) && Object.values(forms?.[note?.value] || {}).length;

  return (
    <>
      <div className="flex w-full flex-wrap gap-4">
        <Input
          className="flex-1"
          id="form-macro-input-name"
          label="Form Macro Name"
          data-qa="enter-form-template-label"
          placeholder="Enter form macro name"
          name="name"
          autoComplete="off"
          value={values?.name}
          onChange={(event) => setFieldValue('name', event.target.value)}
          required={true}
          error={errors?.name}
        />

        {/* <div className="flex w-full gap-x-4">
            <div className="basis-1/2">
              <NoteSelect selectHandler={selectNoteHandler} value={values?.note} />
            </div>
            <div className="basis-1/2">
              <FormSelect
                isButton={false}
                variant="select"
                noteType={note?.value}
                selectedItems={forms}
                selectHandler={selectFormsHandler}
              />
            </div>
          </div> */}
      </div>

      {/* <>
          <div className="my-6 h-px bg-neutral-100"></div>

          {hasForms ? (
            <FormsList
              selectedForms={forms}
              typeOfNotes={typeOfNotes}
              noteType={note?.value}
              className="pb-[200px]"
            />
          ) : (
            <div>
              <div className="flex w-full flex-col items-center justify-center gap-y-1">
                <Icon icon="illustration-choose-enhance-note" className="mb-6" />
                <Typography variant="label" size="large" color="primary-900">
                  Select a form that you want to create a macro!
                </Typography>
                <Typography color="neutral-600">
                  After selecting, the form will be rendered here.
                </Typography>
              </div>
            </div>
          )}
        </> */}
    </>
  );
};

export default FormMacroForm;
